<div class="modal-backdrop" (click)="onClose()"></div>
<div class="modal-content">
  <button class="close-button" (click)="onClose()">X</button>
  <h2>¿Desea este documento para alguna empresa en específico?</h2>
  <form [formGroup]="dateForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="alliedSelect">Compañía</label>
      <select id="alliedSelect" formControlName="alliedSelect" class="filter-select">
        <option value="" disabled>SELECCIONAR</option>
        <option *ngFor="let allied of alliedList" [value]="allied.id">{{ allied.name }}</option>
      </select>
    </div>
    <p class="info-message">
        Si necesita el documento para <strong>todas las compañías</strong> solo pulsa el siguiente boton.
      </p>
    <button type="submit" class="btn-download pointer">Descargar Reporte</button>
  </form>
</div>
